import { render } from "./CommentsSection.vue?vue&type=template&id=c4518862&scoped=true"
import script from "./CommentsSection.vue?vue&type=script&lang=js"
export * from "./CommentsSection.vue?vue&type=script&lang=js"

import "./CommentsSection.vue?vue&type=style&index=0&id=c4518862&scoped=true&lang=css"

import exportComponent from "../../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4518862"]])

export default __exports__